<template>
    <div class="card">
        <div
            v-if="data.cardImage"
            class="card-image"
        >
            <CmsImage
                :data="data.cardImage"
                fit="cover"
            />
        </div>

        <div class="card-content">
            <ContentComponentItems
                :data="data.content"
                :background="data.backgroundColor"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ComponentCardFragment } from '@/graphql/api'
import type { ButtonColors } from '@/components/ui/buttons'
import { getColorForBackground } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'
import type { Colors } from '@/components/ui'

import CmsImage from '@/components/cms/CmsImage.vue'
import ContentComponentItems from '@/components/cms/component/ContentComponentItems.vue'

const props = defineProps<{
    data: ComponentCardFragment
}>()

const backgroundColor = computed(
    (): ButtonColors => cmsColorToButtonColor(props.data.backgroundColor)
)

const color = computed(
    (): Colors => getColorForBackground(backgroundColor.value)
)
</script>

<style lang="scss" scoped>
.card {
    background: v-bind(backgroundColor);
    color: v-bind(color);
    width: 100%;

    @include min-width(768) {
        height: 540px;
        display: flex;
        align-items: flex-start;
    }

    .page-block.flex & {
        @include min-width(1024) {
            width: 60%;
            flex-grow: 1;
        }
    }

    .card-image {
        width: 100%;
        height: 50vw;

        @include min-width(768) {
            order: 2;
            height: 100%;
        }
    }

    .card-content {
        padding: 35px 30px 15px;
        margin-top: auto;

        @include min-width(768) {
            padding-bottom: 35px;
            width: 50%;
            min-width: 390px;
            max-width: 420px;
        }
    }
}
</style>
